<script lang="ts" setup>
	import {cn} from '@/scripts/utils/utils';
	import {
		DropdownMenuLabel,
		type DropdownMenuLabelProps,
		useForwardProps,
	} from 'radix-vue';
	import {computed, type HTMLAttributes} from 'vue';

	const props = defineProps<
		DropdownMenuLabelProps & {
			class?: HTMLAttributes['class'];
			inset?: boolean;
		}
	>();

	const delegatedProps = computed(() => {
		const {class: _, ...delegated} = props;

		return delegated;
	});

	const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<DropdownMenuLabel
		:class="
			cn(
				'px-2 py-1.5 text-sm font-semibold',
				inset && 'pl-8',
				props.class
			)
		"
		v-bind="forwardedProps"
	>
		<slot />
	</DropdownMenuLabel>
</template>
